import { createUserManager as createUserManagerBase } from 'redux-oidc';
import config from '@ers/config';

function createUserManager() {
    return enrichUserManager(createUserManagerBase(createSettings()));
}
function enrichUserManager(userManager) {
    // eslint-disable-next-line no-param-reassign
    userManager.delayedSignoutRedirect = () => {
        const logoutTimeout = setTimeout(() => {
            clearTimeout(logoutTimeout);
            window.location.href = config.authorization.post_logout_redirect_uri;
        }, 1000);
    };
    return userManager;
}

function createSettings() {
    const authConfig = config.authorization;
    const settings = {
        ...authConfig,
        client_id: getClientId(),
        response_type: 'code',
        redirect_uri: getRedirectUri(),
        silent_redirect_uri: getSilentRedirectUri(),
        scope: 'openid candidateAccountPublicApi sessionApi',
        automaticSilentRenew: true,
        accessTokenExpiringNotificationTime: 90,
        includeIdTokenInSilentRenew: false,
        clockSkew: 128000000,
        staleStateAge: 4000,
        checkSessionInterval: 15000,
        silentRequestTimeout: 30000,
        stopCheckSessionOnError: false
    };
    return settings;
}

function getClientId() {
    return `${baseUri()}`;
}

function getRedirectUri() {
    return `${baseUri()}/signin`;
}

function getSilentRedirectUri() {
    return `${baseUri()}/silent-renew`;
}

function baseUri() {
    return `${window.location.protocol}//${window.location.hostname}${window.location.port ? `:${window.location.port}` : ''}`;
}

const userManager = createUserManager();

export const useUserManager = () => userManager;

export default useUserManager;